import { render, staticRenderFns } from "./lawsuit_3.vue?vue&type=template&id=a9a10388&scoped=true"
import script from "./lawsuit_3.vue?vue&type=script&lang=js"
export * from "./lawsuit_3.vue?vue&type=script&lang=js"
import style0 from "./lawsuit_3.vue?vue&type=style&index=0&id=a9a10388&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a10388",
  null
  
)

export default component.exports